import { EmployeeModel } from '../models/employee.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormFactory } from '../../../shared/mappers/form.factory';
import { CustomValidators } from '../../../shared/validators/custom-validators';

export class EmployeeFormFactory {
  static createEmployeeForm(fb: FormBuilder, employeeModel: EmployeeModel): FormGroup {
    return fb.group({
      employeeId: [employeeModel.employeeId],
      categoryIds: fb.array(employeeModel.categoryIds),
      bookingConstraints: FormFactory.createBookingConstraintsForm(fb, employeeModel.bookingConstraints),
      canBook: [employeeModel.canBook, Validators.required],
      externalId: [employeeModel.externalId, [Validators.required, CustomValidators.integer]],
      firstName: [employeeModel.firstName],
      lastName: [employeeModel.lastName]
    });
  }
}
